import React, { Dispatch, SetStateAction } from 'react';
import { Nullable } from 'global';
import { useSelector } from 'react-redux';
import { FilterEvent } from 'components/shared/Filters';
import { VOFilters, VOFilterType } from 'modules/vendorOpportunity';
import { Account, TableFilter } from '@trnsact/trnsact-shared-types';
import { OpportunitiesListTabsType, OpportunitiesTableColumn } from 'modules/vendorOpportunity/list/types';
import { getAvailableSetOfFilters, getSetOfDataFilterOptions } from 'modules/vendorOpportunity/list/lib';

import { TableFilters } from './TableFilters';

interface Props {
  isFiltersOpen: boolean;
  tableFilters: TableFilter[];
  allColumns: OpportunitiesTableColumn[];
  currentTabValue: OpportunitiesListTabsType;
  currentFilterConfig: Nullable<Partial<VOFilters>>;
  setIsFilterOpen: Dispatch<SetStateAction<boolean>>;
  onTableFiltersChanged: (filters: Partial<VOFilters>, event: FilterEvent) => void;
}

export const OpportunitiesTableFilters = ({
  allColumns,
  tableFilters,
  isFiltersOpen,
  setIsFilterOpen,
  currentTabValue,
  currentFilterConfig,
  onTableFiltersChanged,
}: Props) => {
  const account = useSelector((state: any) => state.account) as Account;
  const userProfile = useSelector((state: any) => state.userProfile);

  const isPartner = account.accountType === 'Partner';
  const setOfFilters = getAvailableSetOfFilters(userProfile, isPartner, currentTabValue);

  return (
    <TableFilters
      isOpen={isFiltersOpen}
      setOfFilters={setOfFilters}
      listOfPresets={tableFilters}
      onChanged={onTableFiltersChanged}
      onClose={() => setIsFilterOpen(false)}
      externalMeta={{
        [VOFilterType.SET_OF_DATA]: getSetOfDataFilterOptions(allColumns),
      }}
      defaultExternalFiltersValue={currentFilterConfig}
    />
  );
};
